import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { capitalizeFirstLetter } from "../../../helpers/functions";
import {
  DataField,
  H2,
  P,
  Section
} from "./common-components";
import { AllergicRhinitisDocTypes, MedicationReviewDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const AllergyInformation = ({
  patient,
  formType,
  clinicalAssessment,
  namesOnly = false,
}) => {
  // const { patient, formType, clinicalAssessment } = useContext(FormContextMA);
  
  const isInterventionForm = (() => {
    if (!formType) return false;
    const lowerFormType = formType.toLowerCase();
    return lowerFormType.includes("intervention") || lowerFormType.includes("prescribing");
  })();
  const confirmedIds = (clinicalAssessment?.confirmedAllergy || []).map((id) => String(id));

  const allAllergies = (patient?.allergyInfo?.allergies || []).map((a) => ({ ...a }));

  // Show only active allergies. If there are confirmed allergy ids use those (but only active);
  // otherwise fall back to all recorded active allergies.
  const filteredAllergies = (() => {
    const activeAllergies = allAllergies.filter(
      (a) => String(a?.status || "").toLowerCase() === "active"
    );

    return confirmedIds.length > 0
      ? activeAllergies.filter((f) => confirmedIds.includes(String(f?.id)))
      : activeAllergies;
  })();

  const namesOnlyLayout = Boolean(namesOnly && isInterventionForm);
  const useTable = !namesOnlyLayout && (!isInterventionForm || filteredAllergies.length > 1);

  return (
    <Section formType = {formType}>
      {!isInterventionForm && <H2>Allergy Information</H2>}
      <div className="space-y-2">
        {useTable ? (
          filteredAllergies.length > 0 ? (
            <table className="text-xs border border-gray-400 border-collapse w-full rounded-md">
              <thead>
                <tr className="text-left bg-gray-50">
                  <th className="border font-normal border-gray-400 p-1 w-1/4">Allergy Name</th>
                  <th className="border font-normal border-gray-400 p-1 w-1/4">Type</th>
                  <th className="border font-normal border-gray-400 p-1 w-1/4">Reaction</th>
                  <th className="border font-normal border-gray-400 p-1 w-1/4">Severity</th>
                </tr>
              </thead>
              <tbody>
                {filteredAllergies.map((a) => (
                  <tr className="font-semibold" key={String(a?.id)}>
                    <td className="border border-gray-400 p-1 w-1/4">{capitalizeFirstLetter(a.allergyName)}</td>
                    <td className="border border-gray-400 p-1 w-1/4">{capitalizeFirstLetter(a.type)}</td>
                    <td className="border border-gray-400 p-1 w-1/4">{capitalizeFirstLetter(a.reaction)}</td>
                    <td className="border border-gray-400 p-1 w-1/4">{capitalizeFirstLetter(a.severity)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <DataField value={"No Known Allergies"} />
          )
        ) : (
          <div className="flex items-center">
            <span className="text-teal-300 font-medium mr-2">Allergy Information:</span>
            <span className="font-semibold">
              {filteredAllergies.map(a => capitalizeFirstLetter(a.allergyName)).join(", ") || "No Known Allergies"}
            </span>
          </div>
        )}
        {[AllergicRhinitisDocTypes.InitialAssessment, MedicationReviewDocTypes.PharmacistWorksheet].includes(formType) && <DataField label={"Allergy Information Confirmed with Patient"} />}
      </div>
    </Section>
  );
};
